const initialState = {
  events: [],
  isFetching: false,
  lastUpdate: new Date().getTime(),
}

const handlers = {
  KEY_GAMES_EVENTS: (state) => ({ ...state, isFetching: true }),
  KEY_GAMES_EVENTS_SUCCESS: (state, { payload }) => ({
    ...state,
    events: payload.events,
    isFetching: false,
    lastUpdate: new Date().getTime(),
  }),
  KEY_GAMES_EVENTS_FAILURE: (state) => ({ ...state, isFetching: false }),
}

export default function keyGamesEvents(state = initialState, action) {
  const { type } = action

  return handlers[type] ? handlers[type](state, action) : state
}
